import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.assign";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from "react";
import objectAssign from "object-assign";

var Iframe = function Iframe(_a) {
  var url = _a.url,
      allowFullScreen = _a.allowFullScreen,
      position = _a.position,
      display = _a.display,
      height = _a.height,
      width = _a.width,
      overflow = _a.overflow,
      styles = _a.styles,
      onLoad = _a.onLoad,
      onMouseOver = _a.onMouseOver,
      onMouseOut = _a.onMouseOut,
      scrolling = _a.scrolling,
      id = _a.id,
      frameBorder = _a.frameBorder,
      ariaHidden = _a.ariaHidden,
      sandbox = _a.sandbox,
      allow = _a.allow,
      className = _a.className,
      title = _a.title,
      ariaLabel = _a.ariaLabel,
      ariaLabelledby = _a.ariaLabelledby,
      name = _a.name,
      target = _a.target,
      loading = _a.loading,
      importance = _a.importance,
      referrerpolicy = _a.referrerpolicy,
      allowpaymentrequest = _a.allowpaymentrequest,
      src = _a.src;
  var defaultProps = objectAssign({
    src: src || url,
    target: target || null,
    style: {
      position: position || null,
      display: display || "block",
      overflow: overflow || null
    },
    scrolling: scrolling || null,
    allowpaymentrequest: allowpaymentrequest || null,
    importance: importance || null,
    sandbox: sandbox || null,
    loading: loading || null,
    styles: styles || null,
    name: name || null,
    className: className || null,
    referrerpolicy: referrerpolicy || null,
    title: title || null,
    allow: allow || null,
    id: id || null,
    "aria-labelledby": ariaLabelledby || null,
    "aria-hidden": ariaHidden || null,
    "aria-label": ariaLabel || null,
    width: width || null,
    height: height || null,
    onLoad: onLoad || null,
    onMouseOver: onMouseOver || null,
    onMouseOut: onMouseOut || null
  });
  var props = Object.create(null);

  for (var _i = 0, _b = Object.keys(defaultProps); _i < _b.length; _i++) {
    var prop = _b[_i];

    if (defaultProps[prop] != null) {
      props[prop] = defaultProps[prop];
    }
  }

  for (var _c = 0, _d = Object.keys(props.style); _c < _d.length; _c++) {
    var i = _d[_c];

    if (props.style[i] == null) {
      delete props.style[i];
    }
  }

  if (allowFullScreen) {
    if ("allow" in props) {
      var currentAllow = props.allow.replace("fullscreen", "");
      props.allow = ("fullscreen " + currentAllow.trim()).trim();
    } else {
      props.allow = "fullscreen";
    }
  }

  if (frameBorder >= 0) {
    if (!props.style.hasOwnProperty("border")) {
      props.style.border = frameBorder;
    }
  }

  return React.createElement("iframe", __assign({}, props));
};

export default Iframe;